// extracted by mini-css-extract-plugin
export default {"datePickerWrapper":"styles_datePickerWrapper__kisHH","lossAmountWrapper":"styles_lossAmountWrapper__EsVLh"};